import React from 'react';
import { Form, Field, Button, TextInput } from 'shared';
import useModal from 'hooks/useModal';
import Modal from 'modals/layout';
import {
  createShotflowInstance,
  updateShotflowInstance
} from 'store/integrations';
import { useDispatch } from 'react-redux';
import { displayAlert } from 'store/v1/ui/ui.actions';

const initialInstance = {
  name: '',
  username: '',
  password: '',
  api_url: '',
  app_id: ''
};

const ConfigureShotflowInstanceModal = ({ instance = null }) => {
  const dispatch = useDispatch();
  const { cancelModal, closeModal } = useModal();
  const initialValues = instance || initialInstance;

  const handleSubmit = data => {
    const action = instance ? updateShotflowInstance : createShotflowInstance;
    dispatch(
      action(
        !instance
          ? data
          : {
              ...data,
              id: instance.id
            }
      )
    ).then(_ => {
      dispatch(
        displayAlert(
          'success',
          'Shotflow instance ' + (instance ? 'updated' : 'created')
        )
      );
      closeModal();
    });
  };

  return (
    <Form values={initialValues} onSubmit={handleSubmit}>
      <Modal size="m">
        <Modal.Header title="Configure Shotflow instance" />
        <Modal.Content>
          <Modal.Scrollable>
            <div className="stack-s">
              <Field label="Name" name="name" isRequired>
                <TextInput placeholder="" />
              </Field>
            </div>
            <div className="stack-s">
              <Field label="Username" name="username" isRequired>
                <TextInput placeholder="" />
              </Field>
            </div>
            <div className="stack-s">
              <Field label="Password" name="password" isRequired>
                <TextInput placeholder="" />
              </Field>
            </div>
            <div className="stack-s">
              <Field label="API URL" name="api_url" isRequired>
                <TextInput placeholder="" />
              </Field>
            </div>
            <div className="stack-s">
              <Field label="APP ID" name="app_id" isRequired>
                <TextInput placeholder="" />
              </Field>
            </div>
          </Modal.Scrollable>
          <Modal.Toolbar>
            <Button label="Cancel" action={cancelModal} />
            <Button
              label={instance ? 'Save changes' : 'Create'}
              icon="tick"
              appearance="primary"
              hasMarginLeft
              isLoading={false}
              action="submit"
            />
          </Modal.Toolbar>
        </Modal.Content>
      </Modal>
    </Form>
  );
};

export default ConfigureShotflowInstanceModal;
